import loader from '../loader';

export default loader(() => import('./index.jsx'));
